import React from 'react'
import Text from '../../../Text'
import Spacer from '../../../Spacer'
import styles from './styles.module.css'
import ItemDownloads from '../ItemDownloads'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { downloadsByCategory, TYPES } from '../../../../content/downloads'

// Split a category's downloads (newest-first) into "latest" + "archived".
// Rule (unchanged from the original): if a VRS_ONE_INSTALLER exists it is the
// only "latest"; otherwise the newest file of each type is "latest" (ordered by
// type order) and everything else is archived.
function latestAndArchived(items) {
  const vrsOne = items.find((i) => i.type === 'VRS_ONE_INSTALLER')
  let latest
  if (vrsOne) {
    latest = [vrsOne]
  } else {
    const seen = new Set()
    latest = []
    for (const i of items) {
      if (!seen.has(i.type)) { seen.add(i.type); latest.push(i) }
    }
    latest.sort((a, b) => (TYPES[a.type]?.order ?? 999) - (TYPES[b.type]?.order ?? 999))
  }
  const latestSet = new Set(latest)
  return { latest, archived: items.filter((i) => !latestSet.has(i)) }
}

function DownloadsPageSection({ section = {} }) {
  const { title, text, theme = {}, categoryImages } = section
  const textColor = '#000000'

  return (
    <div className={styles.wrapper} style={{ color: textColor, backgroundColor: theme.value }}>
      <div className={styles.contentWrapper}>
        <div className={styles.downloadItemsWrapper}>
          {/* Single-<h1> rule (Audit A #1): the /downloads + /manuals page title is
              the page's one visible <h1>. `primary` keeps the H2 variant's visual
              class and only swaps the tag to <h1>. */}
          <div className={styles.title}><Text type="H2" primary>{title}</Text></div>
          <div className={styles.textBlock}>
            <SimpleBlockContent blocks={text} noSpace/>
          </div>
          <Spacer size={24} />
          {downloadsByCategory().map(({ category, label, image, items }) => {
            const { latest, archived } = latestAndArchived(items)
            if (!latest.length) return null
            // Prefer the server-resolved descriptor (task #67/#80, injected onto
            // the section in gSSP); fall back to the raw static /assets string
            // (e.g. a non-slug render path that didn't resolve it). ItemDownloads
            // collapses either shape to a URL via toSrc.
            return (
              <ItemDownloads
                key={category}
                itemCategory={category}
                categoryLabel={label}
                categoryImage={(categoryImages && categoryImages[category]) || image}
                latestFiles={latest}
                archivedFiles={archived}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DownloadsPageSection
